import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['../terms/terms.component.css']
})
export class PrivacyPolicyComponent { }
